<template>
  <a-dialog
      ref="dialog"
      :persistent="false"
      size="small"
      name="update_tags"
      @close="$reset"
      @open="open">
    <span slot="title">
      {{ $t('title') }}
    </span>
    <div slot="content">
      {{ $t('description') }}
      <tags-select :value.sync="tags"></tags-select>
      <v-alert class="mt-4 mb-0" type="info" text border="left" icon="mdi-lightbulb-on-outline">
        {{ $t('hint') }}
      </v-alert>
    </div>
    <span slot="actions">
    <v-btn color="primary" text :loading="loading" @click="submit">
      {{ $t('actions.edit') }}
    </v-btn>
    </span>
  </a-dialog>
</template>

<script>
import TagsSelect from '@/views/Common/Components/Selects/TagsSelect'

export default {
  name: 'UpdateTagsDialog',
  components: { TagsSelect },
  data () {
    return {
      loading: false,
      ids: [],
      tags: []
    }
  },
  methods: {
    open ({ ids }) {
      this.ids = ids
    },
    async submit () {
      this.loading = true
      try {
        await this.$repos.monitors.update(this.ids, { tags: this.tags })
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"description": "Edit the tags of all selected keywords with the field below.",
		"hint": "You can modify the tags of a single keyword directly in the table with the click of the pencil (If your data is not grouped by tags).",
		"title": "Edit Tags"
	},
	"es": {
		"description": "Edite las etiquetas de todas las palabras clave seleccionadas con el campo a continuación.",
		"hint": "Puede modificar las etiquetas de una sola palabra clave directamente en la tabla con un clic del lápiz (si sus datos no están agrupados por etiquetas).",
		"title": "Editar etiquetas"
	},
	"fr": {
		"description": "Modifier les tags de tous les mots-clés sélectionnés avec le champ ci-dessous.",
		"hint": "Vous pouvez modifier les tags d'un seul mot clé directement dans le tableau au clic du crayon (Si vos données ne sont pas groupées par tags).",
		"title": "Modifier les tags"
	},
	"it": {
		"description": "Modifica i tag di tutte le parole chiave selezionate con il campo sottostante.",
		"hint": "Puoi modificare i tag di una singola parola chiave direttamente nella tabella cliccando la matita (se i tuoi dati non sono raggruppati per tag).",
		"title": "Modifica tag"
	},
	"pt": {
		"description": "Edite as tags de todas as palavras-chave selecionadas com o campo abaixo.",
		"hint": "Pode modificar as tags de uma única palavra-chave diretamente na tabela com o clique do lápis (se os seus dados não estiverem agrupados por tags).",
		"title": "Editar tags"
	},
	"pl": {
		"description": "Edytuj tagi wszystkich wybranych słów kluczowych za pomocą pola poniżej.",
		"hint": "Możesz zmodyfikować tagi pojedynczego słowa kluczowego bezpośrednio w tabeli klikając ołówek (jeśli dane nie są pogrupowane według tagów).",
		"title": "Edytuj tagi"
	}
}
</i18n>
